export default {
  // 단어
  'profile': 'Account',
  'user': 'User',
  'auto': 'Auto',
  'login': 'Login',
  'logout': 'Logout',
  'ID': 'ID',
  'PW': 'Password',
  'PW_confirm': 'Confirm Password',
  'PW_origin':'Current Password',
  'PW_new':'New Password',
  'PW_new_confirm':'Confirm New Password',
  'SC0010': 'Credit',
  'SC0030': 'Bank Transfer',
  'SC0060': 'Mobile billing',
  'Superadmin': 'Free',
  'Corporate': 'Corporate',
  'Basic': 'Basic',
  'Free': 'Free',
  'Email': 'Email',
  'name': 'Name',
  'phone': 'Phone',
  'office_phone': 'Office Phone',
  'subscription_path': 'How did you hear about us?',
  'windows': 'windows',
  'Windows': 'Windows',
  'linux': 'Linux',
  'mac': 'MAC',
  'android': 'Android',
  'agent': 'Agent',
  'download': 'Download',
  'manual': 'Manual',
  'service': 'Service',
  'payment': 'Payment',
  'manage': ' Management',
  'manager': 'Manager',
  'group': 'Group',
  'information': 'Information',
  'threshold': 'Threshold', // ?
  'limit': 'Limit',
  'alert': 'Alert',
  'setting': 'Setting',
  'settings': 'Settings',
  'normal': 'Normal', // +
  'device': 'Device',
  'type': 'Type',
  'add': 'Add',
  'add_n': 'Add {v}',
  'remove': 'Remove',
  'delete': 'Delete',
  'progress': 'Progress',
  'time': 'Time',
  'hour': 'Hour',
  'minute': 'Minute',
  'second': 'Second',
  'device-in-group': 'Device in Group',
  'list-of': 'List of {v}',
  'total': 'Total',
  'history': 'History',
  'registration': 'Registration',
  'statistics': 'Statistics',
  'update': 'Update',
  'renew': 'Renew',
  'connected': 'Connected',
  'disconnected': 'Disconnected',
  'running': 'Running',
  'sub-manager': 'User',
  // 'execute': 'From > To',
  'execute': 'Execute',
  'cancel': 'Cancel',
  'ea': 'EA',
  'WON': 'Won',
  'months': 'Months',
  'years': 'Years',
  'back': 'Back',
  'expire': 'Expired',
  'notify': 'Notification',
  'help': 'Help',
  'status': 'Status',
  'program': 'Program',
  'web': 'Web',
  'proposal': 'Proposal Document',
  'brochure': 'Brochure',
  'ios': 'iOS',
  'etc': 'Other',
  'on-work': 'Currently Unavailable', // ?
  'list-view': 'List',
  'card-view': 'Simple View',
  'live-view': 'Thumbnail',
  'delete-n': 'Delete {v}',
  'move-group-n': 'Move Group', // +
  'selected': 'Selected',
  'accessable': 'Accessible',
  'empty': 'Empty',
  'device_limit': 'Device Limit',
  'device_name': 'Agent Name',
  'device_name_identical': 'The agent name is identical.',
  'device_name_edit': 'Edit Agent Name',
  'device_name_desc': 'The agent name will be changed from <b>{alias}</b> to the one below.',
  'device_config_desc': 'The configuration information of the selected agents will be updated.',
  'name_input_path': '[Enter a change agent name]',
  'all_different': 'The agent name changes from <b>{alias}</b> to<br><b>{value}</b>. <br><br> The agent config changes from <b>{oldConfigName}</b> to<br><b>{newConfigName}</b>.',
  'device_name_confirm': 'The agent name changes from <b>{alias}</b> to<br><b>{value}</b>.',
  'device_config_confirm': 'The agent config changes from <b>{oldConfigName}</b> to<br><b>{newConfigName}</b>.',
  'device_setting_edit': 'Edit Agent Information',
  'device_apply_config': 'Apply Agent Configuration',
  'device_location': 'View Agent Location',
  'device_setting_desc': '<br>[Enter the change agent configuration]',
  'O/S': 'O/S',
  'edit': 'Edit',
  'refresh': 'Refresh',
  'off-editmode': 'Edit Mode Off',
  'emptied_memo': 'No Memo',
  'upper_group': 'Upper Group',
  'all_device': 'All Agents',
  'submit': 'OK',
  'create': 'Create',
  'delete_group': 'Delete Group',
  'delete_device': 'Delete Device',
  'favorate': 'Favorites',
  'search': 'Search',
  'by_user': '{v} by User',
  'by_device': '{v} by Agent',
  'by_type': '{v} by Type',
  'by_daily': 'Daily',
  'by_monthly': 'Monthly',
  'alert_count': 'Alert Count',
  'use_rate': 'Usage',
  'rate': 'Rate',
  'use_count': 'Count',
  'select_date': 'Select Period',
  'connect_count_of_remote': 'Number of Remote Connection',
  'count_of_alert': 'Number of alerts',
  'chart': 'Chart',
  'date': 'Date',
  'install_date': 'Install Date',
  'host': 'Host',
  'viewer': 'Viewer',
  'at_time': 'Time: ',
  'start_time': 'Start Date',
  'end_time': 'End Date',
  'expire_date': 'Expiration Date',
  'event_time': 'Occurrence Date',
  'login_time': 'Access Time',
  'delete_time': 'Deleted Time',
  'payment_date': 'Payment Date',
  'type_of_device': 'Type of Device',
  'alert_message': 'Alert Message',
  'browser': 'Browser',
  'file_name': 'File Name',
  'size': 'File Size',
  'top10': 'Top 10',
  'change': 'Change',
  'do_change': 'Change',
  'advenced_auth': '2-Step Verification',
  'department': 'Department',
  'cowork_position': 'Job Title',
  'timezone': 'Time Zone',
  'date_format': '@:date format',
  'time_sec': '(seconds)',
  'auto_update': 'Auto Update',
  'active': 'Active',
  'inactive': 'Inactive',
  'permission': 'Permission',
  'target': 'Target',
  'common': 'Common',
  'web_manager': 'Web Manager',
  'CS_manager': 'CS (Program) Manager',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': 'License',
  'regist_service': 'Register @:service',
  'update_service': 'Renew @:service',
  'device_type': 'Plan Type',
  'device_vol': 'Device Volume',
  'remain': 'Remain',
  'period': 'Period',
  'price': 'Price',
  'total_price': 'Total Price',
  'payment_type': 'Product Type',
  'payment_method': 'Payment Method',
  'remark': 'Comment',
  'notice': 'Notice',
  'cs_center': 'Customer Service Center',
  'cs_phone': '070-7126-8663',
  'save': 'Save',
  'find_n': 'Find {v}',
  'signup': 'Sign Up',
  'trial': '15 Days Free Trial',
  'use_for': 'Account Type',
  'personal': 'Personal',
  'enterprise': 'Enterprise',
  'company': 'Company',
  'package_name': 'Package Name',
  'package_id': 'Package ID',
  'app_name': 'App Name',
  'app_version': 'App Version',
  'upload': 'Upload',
  'url': 'URL',
  'file': 'File',
  'action': 'Action',
  'continue': 'Continue',
  'temperature': 'Temp',
  'speed': 'Speed',
  'running_time': 'Running Time',
  'system_time': 'System Time',
  'version': 'Version',
  'access_log': 'Controls',
  'list_of_process': 'Processes',
  'list_of_hardware': 'Hardware List',
  'list_of_software': 'Software List',
  'enter_n': 'Enter your {v}',
  'reset_n': 'Reset {v}',
  'authorization': 'Identity Verification',
  'send_n': 'Send {v}',
  'resend_n': 'Resend {v}',
  'close': 'Close',
  'secure': 'Security',
  'available_count': 'Available Devices',
  'submanager-right': 'Submanager Permission',
  'access-registration-history': 'Remote Access Request History',
  'access-num': 'Access Number',
  'device-name': 'Agent Name',
  'device-ip': 'Device IP',
  'application-date': 'Requested Date',
  'application-period': 'Requested Period',
  'approver': 'Approved by',
  'applicant': 'Requested by',
  'approval-status': 'Status',
  'approval': 'Approved',
  'approval-ing': 'In Progress',
  'function-settings': 'Settings',
  'function-settings01': 'Block Unverified Users',
  'function-settings02': 'Session Idle Time(min.)',
  'function-settings03': 'File Transfer',
  'blocking-settings': 'Permission',
  'blocking-settings01': 'Blocking Policy',
  'approval-submit-user': 'Re-Apply',
  'blocking-super-settings': 'IP Management Policy',
  'reset-pw': 'Reset',
  'reject-submit': 'Deny',
  'reject': 'Denied',
  'security-access': 'Agree',
  'manager-id': 'Administrator',
  'sub-manager-id': 'Submanager',
  'reject-access': 'Deny',
  'request-agent': 'Request Agent',
  'request-date': 'Request Date',
  'request-reason': 'Reason for Request',
  'approval-reason': 'Reason for Approval',
  'security-access-title':'Agree to Security Policy',
  'excel-form':'Download Excel Form',
  'approval-apply':'Use Approval Process',
  'user-in-group':'Users in Group',
  'deleted-device-edit':'Edit',
  'request-history':'Request History',
  'approval-process':'Request',
  'approval-process-history':'Approval History',
  'major-os-version':'Major OS Version',
  'minor-os-version':'Minor OS Version',
  'session-time':'Session Duration Time(min.)',
  'account_security': 'Account Security',
  // @@@
  'password_level' : 'Password Difficulty',
  'password_level0' : 'No limit (4 to 12 digits)',
  'password_level1' : 'Alphabetical letters and numbers only (6 to 12 digits).',
  'password_level2' : 'Alphabetical letters, numbers and special characters (8 to 12 digits).',
  'password_level3' : 'Uppercase and lowercase letters, numbers, and special characters (8 to 12 digits).',
  'self_unlock' : 'Allow self-unlock when account is locked',
  'self_unlock_desc' : 'Users can unlock their own accounts via self-authentication.',
  'statistics_policy' : 'Statistics Period Settings\n',
  'day' : 'day',
  'month' : 'month',
  'year' : 'year',
  'no-agent-selected': 'No agent has been selected.',
  'statistics_period' : 'Period',
  'vaccine':'Antivirus Software',
  'capture':'Screenshot & Record',
  'display-power-save':'Display Power Saving',
  'system-power-save':'System Power Saving',
  'security-agreement':'Security Oath',
  'remote-policy':'Remote Access Policy',
  'user-connection-policy':'User Environment Policy',
  'os-version':'OS Version Check',
  'blocking-settings-ip-list':'Allowed IP List',
  'single-ip':'Single IP Address',
  'reason':'Comment',
  'range-ip-start':'Start Range',
  'range-ip-end':'End Range',
  'subnet-ip':'Subnet Mask',
  'time-added':'Time Added',
  'ip-address':'IP Address',
  'password-expired':'Password Maximum Age (days)',
  'excel-users': 'Add Multiple Users',
  'enrollment': 'Submit',
  'excel-groups': 'Add Multiple Groups',
  'account-manage':'Account',
  'all-devices':'Agents',
  'tutorial':'Quick Guide',
  'device-drop-all':'All Devices',
  'service-payment-history':'Payment History',
  'tutorial-device':'First time? Learn how to add a remote device.',
  'tutorial-group':'Need help with group management?',
  'tutorial-manager':'Learn more about user management.',
  'tutorial-statistics':'What is the dashboard for?',
  'tutorial-download':'Agent download links and installation guides.',
  'tutorial-license':'Need help with online payment?',
  'first-add-device':'Add remote device',
  'system-checker': 'System Checker Tool',
  'execute-or-not': 'Execute Or Not',

  // 메세지
  'no-selects': 'No selection.',
  'no-content': 'No record.',
  'on_working': 'In Progress',
  'has_new_message': 'New Message',
  'not_save_warning': 'Changes will not be saved. Do you want to proceed?',
  'not_online_warning': 'Device is offline.',
  'no_input_data': 'No data was entered.',
  'add_child_group': 'Add subgroup in "{name}".<br>Please enter group name.',
  'add_root_group': 'Add subgroup in "ROOT".<br>Please enter group name.',
  'duplication_group_name': 'Group name already exists.',
  'created_group': 'Group has been created.',
  'please_select_group': 'Please select group.',
  'confirm_delete_group': 'Devices within this group will be moved to the default group.<br>Are you sure you want to delete?',
  'deleted_group': 'Group deleted.',
  'all_device_has_no_child': 'You can not include "All Device" in a subgroup.',
  'confirm_delete_device': ` 
    The agent program on the remote machine is logged out.<br>
    If you want to regain control of your device afterwards, you have to log in manually for the first time.<br>
    Are you sure you want to delete?
    <br><br>
    Target: {name} 
  `,
  'access-ticket': '제어권 신청',
  'ticket-request': '제어권 신청 관리',
  'at.requested': '승인요청중',
  'at.re-requested': '재승인요청중',
  'at.approved': '승인완료',
  'at.on-work': '작업중',
  'at.reject': '반려됨',
  'at.completed': '종료',
  'at.Unknown': '알수없는상태',

  'has_request_ticket': '{count}개의 제어권 신청이 있습니다',

  'deleted_device': 'Device Deleted',
  'moved_device': '[{device}] moved to [{group}]',
  'moved_device_by': '[{device}] [{group}]', // ?
  'moved_device_fail': 'Cannot move {name}',
  'deleted_device_count': '[{count}/{total}] Device(s) Deleted.',
  'no_order_warning': 'Cannot modify group order.',
  'delete_user_confirm': 'Are you sure you want to delete this user?',
  'user_active_changed': '"{name}" has been changed to "{status}".',
  'deleted_user': 'User Deleted',
  'created_user': 'User Added',
  'updated_memo': 'Memo Modified',
  'update_agent_requested': 'Update has been requested.',
  'update_agent_desc': 'Update the agent program on the remote device.<br>Current version: {current_ver} Latest version: {latest_ver}',
  'update_agent_descs': 'Update the agent program on the remote devices.',
  'delete_threshold': 'Do you want to delete this warning?',
  'no_perm_group': 'You have no access to this group.',
  'add_permission_of_group': `
    Permissions on the parent group below are required to authorize this group.
    <br><br>
    [{groups}]
    <br><br>
    Do you want to allow it?
  `,
  'delete_permission_of_group': `
    To remove the permissions for this group, you need to remove the permissions for the subgroups below.
    <br><br>
    [{groups}]
    <br><br>
    Do you want to allow it?
  `,
  'please_select': 'Please select',
  'please_input': 'Please enter',
  'please_select_device_type': '@:please_select device type',
  'please_select_alert_type': '@:please_select alert type',
  'please_input_alert_time': '@:please_input time',
  'please_input_alert_value': '@:please_input limit',
  'please_input_memo': '@:please_input memo',
  'permissions': {
    'deviceMonitor': 'Monitoring',
    'CSRemoteControl': 'Remote Control',
    'CSFileManager': 'File Transfer',
    'modifyInformation': 'Modify Info',
    'useFunction': 'Reboot/Shutdown',
    'viewReport': 'See Statistics/History',
    'CSRemoteView': 'Remote View',
    'CSDeviceManagement': 'Man. Device',
    'CSUpdate': 'Update Agent',
    'CSThumbnailView': 'See Thumbnail',
    'CSRestart': 'Reboot'
  },
  'getin_with': {
    'internet_search': 'Internet Search',
    'recommendation': 'Recommendation',
    'advertising': 'Advertising',
    'sns': 'Social media/blog',
    'pcany': 'PCAny Pro user',
    'etc': 'Other'
  },
  'added_device_in_group': 'Device added in group',
  'removed_device_in_group': 'Device removed in group',
  'changed_group_info': 'Group Info changed',
  'remote': {
    'remote': {
      'title': 'Remote Access',
      'title2': 'CONNECT',
      'desc': 'Do you want to start remote control?',
      'desc_additional': '<br>(If the remote connection fails, please click the download button to download and run the program.)',
      'download': 'Please run the launcher once it has been downloaded.',
    },
    'transfer': {
      'title': 'File Transfer',
      'desc': 'Do you want to start file transfer?'
    },
    'reboot': {
      'title': 'Device Reboot',
      'desc': 'Do you want to reboot?'
    },
    'restart': {
      'title': 'Restart Agent',
      'desc': 'Do you want to restart?',
      'descs': 'Do you want to restart the agent programs that is currently online?',
      'requested': 'Request to restart has been made.'
    },
    'shutdown': {
      'title': 'Device Shutdown',
      'desc': 'Do you want to start shutdown?'
    },
    'preview': {
      'title': 'Screenshot'
    },
    'detail': {
      'title': 'Information'
    },
    'delete': {
      'title': 'Delete Agent'
    },
    'wol': {
      'title': 'WOL',
      'desc': 'Wake "{device}" up use below devices. Select device.'
    },
    'approve' : {
      'title': 'Access Denied',
      'desc': 'Request Access'
    },
    'web': {
      'title': 'Remote Access (Web Viewer)'
    },
    'normal' : {
      'title': 'Remote Access'
    }
  },
  'columns': {
    'alive': 'Status',
    'actions': 'Functions',
    'alias': 'Agent Name',
    'memo': 'Memo',
    'last_connected_time': 'Last Access Date',
    'group': 'Group',
    'connect': 'Connect'
  },
  'id_exist': 'ID does exist.',
  'reserved': {
    'ROOT': 'ROOT'
  },
  'audit-message': {
    '1': 'Performed a remote control function.',
    '2': 'Performed file manager functions.',
    '3': 'The system has been restarted.',
    '4': 'You have shut down the system.',
    '5': 'Updated the agent to the latest version.',
    '11': 'Renamed the device from \'{old_value}\'to \'{new_value}\'',
    '12': 'Changed the note on the device from \'{old_value}\'to \'{new_value}\'',
    '21': 'Moved a group from \'{old_value}\'to \'{new_value}\'',
    '30': 'Changed from {old_value} to {new_value}.',
    '31': 'Reservation (Turn On): Added {new_value}.',
    '32': 'Reservation (Turn Off): Added {new_value}.',
    '33': 'Reservation (Turn On): Removed the {new_value}th setting.',
    '34': 'Reservation (Turn Off): Removed the {new_value}th setting.',
    '35': 'Remote Control: Executed {new_value}.'
  },
  'response_error_server_error': 'A temporary error occurred while fetching data. Please try again in a moment.',
  'response_error_connect_failed': 'We were unable to connect to the server, please try again in a moment.',
  'not_supported_os': 'Unsupported operating system.',
  'online_agents_restart': 'The restart of the online agents has been requested.',
  'all_agents_restart': 'The restart of all agents has been requested.',
  'alert_license': 'License expiration alert',
  'need_license': 'Requires {v} license.',
  'invalid_id_and_pw': 'Please check your ID and password.',
  'login_failed_cause_step1': 'Please check your ID and password.',
  'login_failed_cause_step2': 'Email authentication has not been performed.<br>If you have not received the authentication mail, please press the "Resend Authentication Mail" button.',
  'login_failed_cause_flag_active': 'Your account has been deactivated.<br>Please ask the person in charge.',
  'login_failed_cause_superadmin': 'External access is restricted.',
  'invalid_id': 'Please enter a valid ID.',
  'name_requirement': 'Please enter your name.',
  'phone_requirement': 'Please enter your phone number.',
  'subspath_requirement': 'Please enter your subscription path.',
  'company_name_requirement': 'Please enter your company name.',
  'free_trial_message': '<strong>5 Devices FREE During 15 days!</strong>Join Success!',
  'enter_new_password': 'Enter a new password',
  'accessable_user_desc': 'A list of users with device access in that group.',
  'password_requirement': 'Password must be 8-12 characters, consisting ALL of the following: number, lowercase letter, uppercase letter, and special character.',
  'password_confirm': 'Passwords do not match.',
  'password_modify_mail_sent': 'A password change email has been sent.',
  'password_modified': 'Your password has been changed.',
  'password_modified_failed': 'Password change failed.',
  'otp_reset_complete': 'OTP has been initialized.',
  'otp_reset_failed': 'OTP failed initialization.',
  'password_reset_desc': 'Please reset your password.',
  'forgot_desc': 'Your ID (email) or password could not be found.<br>If you can&#39;t solve it, please contact the customer center.',
  'expired_desc': 'Please renew your existing license or <br>select a device to delete to continue using it.',
  'email-invalid': 'Please enter the correct email.',
  'email-auth-wait': 'Email authentication in progress.<br>Please wait.',
  'email-auth-already': 'Email authentication already completed',
  'email-auth-fail': 'Email authentication failed',
  'email-auth-success': 'Email authentication succeeded.<br>Please log in.',
  'login_description': 'You can access all your PC, smart devices, and IoT devices',
  'join_description': 'Sign up for a free trial.',
  'go_login': 'Login',
  'your_email_is': 'Your ID is<br>{email}',
  'not_matched_user': 'No matching users found.',
  'is_pcany_customer': 'Are you currently a paid customer of PCAny?',
  'add_manager_desc': `
    <div>1. Users can be used immediately after creation without any additional authentication.</div>
    <div>2. Admin ID can see all the agent devices that are logged in with the child user ID.</div>
    <div>3. You can set permissions for each User and a group of devices that you can view.</div>
  `,
  'free_trial_comment': 'This is a free trial. Click the renew button to extend your plan!',
  'secure_login_desc': '만약 보안코드 6자리를 확인할 수 없다면<br>고객센터로 연락주시기 바랍니다.',
  'payment_tax_desc1': '*부가세 포함이며, 1년 약정시 2개월분 금액이 할인됩니다.<br>** 제품 유형(라이센스) 변경 및 1년이상 장기 약정 희망시 고객 센터로 문의 바랍니다.<br>전화번호 : 070-7126-8663',
  'payment_tax_desc2': '세금계산서 필요시 입금 안내',
  'payment_tax_desc3': '전자결제를 진행하신 고객은 전자세금계산서 발급이 불가합니다.<br>세금계산서 발행을 원하실 경우 아래 계좌로 직접 입금하신 후 연락 주시기 바랍니다.<br>우리은행 (주) 링크미마인 1005-402-963384',
  'OTP_desc': 'Web Manager Login 2 Step Verification with Google Authenticator',
  'agreement': {
    'desc': 'Please agree to the terms and conditions of use and personal information.',
    'agree_all': 'I agree to all terms and conditions',
    'agree_use': 'Accept the Terms and Conditions',
    'agree_use_context': `
      [Terms of Services]

      PCCL, Inc. (“PCCL” or “we”) provides the PCCL Web site including the PCCL Home Page and other PCCL contents including application program (collectively, the “PCCL Site”) subject to Customer’s compliance with the terms and conditions below.

      This is a legal agreement between the individual or legal entity (“Customer” or “You”) agreeing to these Terms of Service (“Terms”) and PCCL.By accepting these Terms, signing an Order, or using the services, or checking the acceptance button on the page or application program and completing the electronic acceptance process, you represent and warrant that you

      1. are, or are authorized to sign for, the contracting party defined herein as 'Customer'.
      2. have read, understand and agree to be bound by all of the terms and conditions of this online subscription agreement.
      3. are of legal age and have authority to bind the Customer to the Order, these Terms, and the applicable “Service Descriptions” available at PCCL Site.

      PLEASE READ THIS BEFORE ACCESSING THE PCCL SITE. BY ACCESSING THE PCCL SITE, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS BELOW.   IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS AND CONDITIONS, YOU MAY NOT ACCESS OR USE THE PCCL SITE.

      This online subscription agreement ('Agreement') entered into of the date of electronic acceptance by Customer ('Effective Date'), by and between PCCL and Customer, entering into this Agreement. PCCL reserves the right to revise this Agreement from time to time without notice to Customer.


      Basic Rules

      While visiting the PCCL Site, Customer may also not: post, transmit or otherwise distribute information constituting or encouraging conduct that would constitute a criminal offense or give rise to civil liability, or otherwise use the PCCL Site in a manner which is contrary to law or would serve to restrict or inhibit any other user from using or enjoying the PCCL Site or the Internet; post or transmit any information or software which contains a virus, cancelbot, trojan horse, worm or other harmful or disruptive component; upload, post, publish, transmit, reproduce, or distribute in any way, information, software or other material obtained through the PCCL Site which is protected by copyright, or other intellectual property right, or derivative works with respect hereto, without obtaining permission of the copyright owner or rightsholder.

      You agree to use the Service in accordance with the use levels by which we measure, price and offer our Services as posted on PCCL Site, your Order, or the Service Descriptions (“Use Levels”). You may use our Services only as permitted in these Terms, and you consent to our Privacy Policy at PCCL Site.


      Services

      PCCL grants you a limited right to use PCCL Services for business and professional purposes only. Technical support for the Services is described in the Service Descriptions of PCCL Site. If your affiliates use our Services, you warrant that you have the authority to bind those affiliates and you will be liable if your affiliates do not comply with the Agreement.

      Customer may use PCCL remote software and related services only to enable a designated user to provide remote assistance to its customers. Customer may use PCCL   the Services only to enable authorized individuals to access and control designated users’ PCs and smart devices remotely.

      PCCL reserves the right to upgrade, enhance, or modify functions & features of the Services as it considers appropriate and in its discretion. PCCL will not materially reduce the core functionality (as set forth in the Service Descriptions) or discontinue any Services unless PCCL provides you with prior written notice. PCCL may offer additional functionality to our standard Services or premium feature improvements for an additional cost.

      Customer must complete the online registration process including this Agreement. PCCL may reject an online registration by a potential Customer in its sole discretion and is not obligated to provide a reason for the rejection. Customer or on behalf of Customer shall provide all registration data in accurate, current, and complete. The registration data should be updated by Customer in its sole responsibility. PCCL reserves the right to terminate this Agreement immediately in the event submitted registration data is found to be inaccurate, not current, or incomplete.

      During online registration process, PCCL will collect additional information on billing and payment related matters. It will include a valid credit card or debit card number with available credit, preferred billing frequency, and other information required by PCCL. PCCL reserves the right to terminate the Agreement immediately in the event any payment information is found to be inaccurate, not current or incomplete. Any overdraft charge or other fees that may be issued by PCCL’s use of Customer’s credit or debit card shall not be PCCL’s responsibility.

      Customer is entirely responsible for all activities under its account including management of keeping confidentiality of its password and account. Customer shall agree to inform PCCL immediately of any type of security breach. PCCL shall not be liable for any loss aroused from the Customer’s activity which may bring as a result of other entity using its password or account, either with or without its knowledge. Customer may be held liable for losses incurred by PCCL in such case as described above.

      Customer is responsible for all subscription fees and all applicable taxes (sales tax, value-added tax, goods and services tax, withholding tax, tarriffs, Universal Services Fund (USF) fees or any other similar fees and taxes) (collectively, the “Taxes and Fees”). Upon Customer’s payment of subscription fees, PCCL will allow Customer to access and use the services described above. All contents transferred by Customer or any other party in connection with Customer’s access and/or use of the services, of all kinds of communication methods, are shall be Customer’s responsibility. All payments you make to us for access to the Services are final and non-refundable. You are responsible for all fees and charges imposed by your voice and data transmission providers related to your access and use of the Services.

      Customer may order Services using our then current ordering processes (“Order”). All Orders are effective on the earlier of the date you submit your Order or the date on the signature block of the Order (collectively, the “Effective Date”). Acceptance of your Order may be subject to our verification and credit approval process. 
      Customer is responsible for providing accurate and current billing contact and payment information to us or any reseller of ours. You agree that PCCL may take steps to verify whether your payment method is valid, charge your payment card or bill you for all amounts due for your use of the Services, and automatically update your payment card information using software designed to do so in the event your payment card on file is no longer valid. You agree that your credit card information and related personal data may be provided to third parties for payment processing and fraud prevention purposes. PCCL may suspend or terminate your Services if at any time PCCL determines that your payment information is inaccurate or not current, and you are responsible for fees and overdraft charges that PCCL may incur when we charge your card for payment. PCCL will not agree to submit invoices via any online portal. PCCL reserve the right to update the price for Services at any time after your Initial Term, and price changes will be effective as of your next billing cycle. PCCL will notify you of any price changes by publishing on our website, emailing, quoting or invoicing you.

      PCCL may offer a trial and/or promotional offers (promotions and other special discounted pricing offers) from time to time and the offers are temporary and upon the renewal of your subscription, any such discounted pricing offers may expire. PCCL reserves the right to discard or change coupons, credits, trials and promotional offers at its discretion and without notice. Just one (1) offer per customer is applied basically and limited to any kind of trial or promotional offers.

      You must notify us of any fee dispute within 15 days of the invoice date, and once resolved, you agree to pay those fees within 15 days. PCCL may, on notice to you, suspend or terminate your Services if you do not pay undisputed fees, and you agree to reimburse us for all reasonable costs and expenses incurred in collecting delinquent amounts.

      Customer must not reverse engineer, decompile or otherwise attempt to decipher any code in connection with the services or any other aspect of PCCL’s technology. Customer shall not access and/or use any of the services in any manner that could damage, disable, overburden, impair or otherwise interfere with or disrupt PCCL Site, services or related systems of PCCL. Customer may not resell, distribute, or use any of the services on a timeshare or disapproved method basis.


      Monitoring

      PCCL has no obligation to monitor the PCCL Site. However, Customer agrees that PCCL has the right to monitor the PCCL Site electronically from time to time and to disclose any information as necessary to satisfy any law, regulation or other governmental request, to operate the PCCL Site properly, or to protect itself or its subscribers. PCCL will not intentionally monitor or disclose any private electronic-mail message unless required by law. PCCL reserves the right to refuse to post or to remove any information or materials, in whole or in part, that, in its sole discretion, are unacceptable, undesirable, or in violation of this Agreement.


      Termination

      PCCL reserves the right to terminate this Agreement immediately if Customer breaches any of its material obligations under the Agreement. Upon termination of the Agreement, Customer will immediately stop access to and use of the services. PCCL shall not be liable for any damages resulting from a termination of the Agreement. Provided, claims arising prior to the termination shall not be affected.


      The initial term commitment for your purchase of Services will be as specified on an Order (“Initial Term”) and begins on the Effective Date. After the Initial Term, the Services will, unless otherwise specified in the Service Description for a particular Service, automatically renew for additional 1-year periods (“Renewal Terms”), unless either party provides notice of non-renewal at least 30 days before the current term expires. You may provide notice of non-renewal for each Service you do not wish to renew at PCCL Site contacts. PCCL may agree to align the invoicing under multiple Orders but this will not reduce the term of any Order. Terminating specific Services does not affect the term of any other Services still in effect. If we permit you to reinstate Services at any time after termination, you agree that you will be bound by the then-current Terms and the renewal date that was in effect as of the effective termination date.

      If the Agreement or any Services are terminated, your account may be converted to a dormant account at our discretion. Otherwise, you will immediately discontinue all use of the terminated Services, except that upon request, PCCL will provide you with limited access to the Services for a period not to exceed 30 days, solely to enable you to retrieve your Content from the Services. PCCL has no obligation to maintain your Content after that period. Neither party will be liable for any damages resulting from termination of the Agreement, and termination will not affect any claim arising prior to the effective termination date.

      You retain all rights to your Content (defined below) and PCCL does not own or license your Content. PCCL may use, modify, reproduce and distribute your Content in order to provide and operate the Services. You warrant that you have the right to upload or otherwise share Content with us, and your uploading or processing of your Content in the context of our Services does not infringe on any rights of any third party. Each party agrees to apply reasonable technical, organizational and administrative security measures to keep Content protected in accordance with industry standards. PCCL will not view, access or process any of your Content, except when it is authorized or instructed by you or your users in this Agreement or in any other agreement between the parties, or when it is required to comply with our policies, applicable law, or governmental request. You agree to comply with all legal duties applicable to you as a data controller by virtue of the submission of your Content within the Services. If your Content, including any personal data, is processed by us as a data processor acting on your behalf (in your capacity as data controller), PCCL will use and process your Content in order to provide the Services and fulfill our obligations under the Agreement, and in accordance with your instructions as represented in this Agreement. “Content” means any files, documents, recordings, chat logs, transcripts, and similar data that PCCL maintains on your or your users’ behalf, as well as any other information you or your users may upload to your Service account in connection with the Services.

      Privacy

      It is therefore recommended that the services shall not be used for the transmission of confidential information. PCCL cannot ensure or guarantee privacy for PCCL users. Any such use shall be at the sole risk of Customer and other users in connection with Customer, and PCCL and its affiliate and related companies shall be relieved of all liability in connection therewith.


      Limitation of Liability

      PCCL takes no responsibility for the accuracy or validity of any claims or statements contained in the documents and related graphics on the PCCL Site. Further, PCCL makes no representations about the suitability of any of the information contained in software programs, documents and related graphics on the PCCL Site for any purpose. All such software programs, documents and related graphics are provided without warranty of any kind. In no event shall PCCL be liable for any damages whatsoever, including special, indirect or consequential damages, arising out of or in connection with the use or performance of information available from the service. PCCL’s liability is limited to maximum $50.

      If Customer is dissatisfied with the PCCL Site or with any terms, conditions, rules, policies, guidelines, or practices of PCCL in operating the PCCL Site, Customer’s sole and exclusive remedy is to discontinue using the PCCL Site.


      Confidential Information
      Both parties shall not disclose non-public information or materials which are reasonably understood to be confidential (“Confidential Information”) except the case of any information that receiving party of Confidential Information is obligated to produce pursuant to an order of a court of competent jurisdiction with timely notice to disclosing party. Customer will keep in strict confidence all passwords and other access information to the services.

      Customer shall authorize PCCL to collect from any party and to retain all relevant information relating to Customer’s use of the PCCL Site, and hereby authorize any party to provide PCCL with such information. Customer shall understand and agree that unless Customer notify PCCL to the contrary by e-mailing, Customer further authorize PCCL to disclose, on a confidential basis, to any party with whom PCCL has business relations all relevant information relating to Customer’s dealings with PCCL and the PCCL Site.


      Indemnity

      Customer agrees, at its sole expense, to defend, indemnify and hold PCCL and its affiliate and related companies harmless from any and all liabilities, costs and expenses, including reasonable attorneys' fees, related to a third party claim, suit, or infringement based on information, data, or any content submitted by Customer or related to any Violation of this Agreement by Customer or users of Customer’s account, or in connection with the use of the PCCL Site or the Internet or the placement or transmission of any message, information, software or other materials on the PCCL Site or on the Internet by Customer or users of Customer’s account.



      Trademarks & Proprietary Rights

      PCCL and other names, logos and icons identifying PCCL and PCCL' products and services referenced herein are trademarks or registered trademarks of PCCL, Inc. All other product and/or brand or company names mentioned herein are the trademarks of their respective owners. PCCL, Inc. retains ownership of all proprietary rights in or associated with all its products and services.


      DISCLAIMER
      CUSTOMER HEREBY ACKNOWLEDGES AND AGREES THAT ALL MATERIALS CONTAINED IN THE SERVICES IS PROVIDED BY PCCL ON AN "AS IS" BASIS, AND CUSTOMER’S ACCESS TO AND/OR USE OF THE SERVICES IS AT ITS SOLE RISK WITHOUT WARRANTY OF ANY KIND. THE ENTIRE RISK AS TO THE RESULTS AND THE PERFORMANCE OF THE SOFTWARE IS ASSUMED BY THE USER, AND IN NO EVENT WILL PCCL BE LIABLE FOR ANY CONSEQUENTIAL, INCIDENTAL OR DIRECT DAMAGES SUFFERED IN THE COURSE OF USING THE SOFTWARE IN THE SERVICES. USE OF ANY MATERIAL AND/OR DATA DOWNLOADED OR OBTAINED PROGRAMS (INCLUDING PLUG-INS) CONTAINED IN THE SERVICES IS DONE AT THE SOLE RISK OF CUSTOMER. CUSTOMER WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO ITS COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF SUCH MATERIAL AND/OR DATA.


      Headings

      The headings used in this Agreement are used for convenience only and are not to be considered in construing or interpreting this Agreement.


      Force Majeure

      PCCL shall not be responsible for delays or failure to perform resulting from acts beyond the reasonable control of such party and which could not have been reasonably foreseen and provided against and with respect to which such party shall exercise continuing diligence to resume performance of its obligations. Such acts shall include, without limitation, acts of God, fires, casualties, floods, earthquakes, acts of war, strikes, lockouts, epidemics, destruction of production facilities, riots, insurrections, walkouts, government order, power failures, and other disasters.


      No Waiver & Severability

      The failure of either Customer or PCCL in any one or more instance(s) to insist upon strict performance of any of the terms of this Agreement will not be construed as a waiver or relinquishment of the right to assert or rely upon any such term(s) on any future occasion(s). In the event that any provision of this Agreement (or portion thereof) is determined by a court of competent jurisdiction to be invalid or otherwise unenforceable, such provision (or part thereof) shall be enforced or, incapable of such enforcement, shall be deemed to be deleted from this Agreement, while the remainder of this Agreement shall continue to remain in full force and effect according to its stated terms and conditions.


      COMPLIANCE WITH LAWS. IN CONNECTION WITH THE PERFORMANCE, ACCESS AND USE OF THE SERVICES UNDER THE AGREEMENT, EACH PARTY AGREES TO COMPLY WITH ALL APPLICABLE LAWS, RULES AND REGULATIONS INCLUDING, BUT NOT LIMITED TO EXPORT, PRIVACY, AND DATA PROTECTION LAWS AND REGULATIONS. IF NECESSARY AND IN ACCORDANCE WITH APPLICABLE LAW, PCCL WILL COOPERATE WITH LOCAL, STATE, FEDERAL AND INTERNATIONAL GOVERNMENT AUTHORITIES WITH RESPECT TO THE SERVICES. NOTWITHSTANDING ANY OTHER PROVISION IN THESE TERMS, WE MAY IMMEDIATELY TERMINATE THE AGREEMENT FOR NONCOMPLIANCE WITH APPLICABLE LAWS.


      WARRANTIES. WE WARRANT THAT THE SERVICES WILL CONFORM TO THE SERVICE DESCRIPTIONS UNDER NORMAL USE. WE DO NOT REPRESENT OR WARRANT THAT (1) THE USE OF OUR SERVICES WILL BE TIMELY, UNINTERRUPTED OR ERROR FREE, OR OPERATE IN COMBINATION WITH ANY SPECIFIC HARDWARE, SOFTWARE, SYSTEM OR DATA, (2) OUR SERVICES WILL MEET YOUR REQUIREMENTS, OR (3) ALL ERRORS OR DEFECTS WILL BE CORRECTED. USE OF THE SERVICES IS AT YOUR SOLE RISK. OUR ENTIRE LIABILITY AND YOUR EXCLUSIVE REMEDY UNDER THIS WARRANTY WILL BE, AT OUR SOLE OPTION AND SUBJECT TO APPLICABLE LAW, TO PROVIDE CONFORMING SERVICES, OR TO TERMINATE THE NON-CONFORMING SERVICES OR THE APPLICABLE ORDER, AND PROVIDE A PRO-RATED REFUND OF ANY PREPAID FEES FROM THE DATE YOU NOTIFY US OF THE NON-CONFORMANCE THROUGH THE END OF THE REMAINING TERM. TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM ALL OTHER WARRANTIES AND CONDITIONS, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING ANY EXPRESS OR IMPLIED WARRANTIES OF MERCHANTABILITY, SATISFACTORY QUALITY, TITLE, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES AND CONDITIONS, THEREFORE SOME OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO CUSTOMERS LOCATED IN THOSE JURISDICTIONS.




    `,
    'agree_privacy': 'Accept to the collection/use of personal information',
    'agree_privacy_context': `
      [Privacy Policy]

      PCCL service, as described in Terms of Service of PCCL Site, is a remote support service provided by PCCL, Inc. In this Privacy Policy, we explain what personal data we collect from visitors to the PCCL website(s) and/or properties that link to this Privacy Policy (including digital properties) and how we use such personal data.

      Your privacy is important to us. To protect your privacy better, we provide this policy explaining our online information practices and the choices you can make about the way your information is collected and used. To make this policy easy to find, we make it available on our website(s) and at every point where personally identifiable information may be requested.

      When you visit our website(s), and/or use our Services, you provide following personal data to us. 

      Data Information and Collection

      This notice applies to all information collected or submitted on the PCCL Site. On some pages, you can order products, make requests, and register to receive services and related materials. The types of personal information that you provide at these pages are typically including first and last name, billing data, and a valid email address, postal address, and other demanding information for the service when you create your account with us, request support or technical assistance, or register for events, webinars, whitepapers and surveys.
      We need this data to provide the Services to you, to maintain and support your account, as well as to collect payment. Legal basis for the processing of this data is our legitimate interest to do business with you, your employer or business and perform our contractual obligations under the applicable Services agreement.

      When you use our Services, we receive information through the use of the Service, either voluntarily entered by you or others who use the Services with you, or from the Service infrastructure itself. Service Data includes session and usage data, device information, as well as data automatically logged by the website(s) or Services, for example, duration of session, connections made, hardware, equipment and devices used, IP addresses, location, language settings, operating system used, unique device identifiers, IP addresses and other diagnostic data to help us provide better Services.


      Use of Information Collected

      We use the information you provide about yourself when you are using our services, placing and completing an order, and doing other activities of or related to our website(s) and services. We do not share this information with outside parties except to the extent necessary to maintain the services, to complete that order, to confirm processes, and to analyze our website(s).
      We use the data we collect from visitors to our website(s). 
      1) to provide and operate our Services; 
      2) to maintain and improve our Services; 
      3) to provide product updates, marketing communications, and service data; 
      4) to provide analysis or valuable data back to our customers and users; 
      5) to address and respond to service, security, and customer support needs; 
      6) to detect, prevent, or otherwise address fraud, security, unlawful, or technical issues; 
      7) to display content based upon your interests; 
      8) to comply with applicable laws and administrative requests, protect our rights, assert and defend against claims; 
      9) to fulfill contracts; 
      10) to assess the needs of your business to determine and promote other related products which we believe may be helpful to you; 
      11) to conduct research and analysis for business planning and product development; 
      12) to the extent permitted by law, we may combine, correct and enrich personal data that we receive from you with data about you from other sources, including publicly available databases or from third parties to update, expand and analyze our records, identify new prospects for marketing, and provide products and Services that may be of interest to you.
      We continuously improve our website(s) and Services through the use of web analytics tools and first and third-party cookies, which help us understand how our visitors use our website(s), desktop and mobile applications, what webpages, features and functions they like and dislike, and where they may have run into problems which need to be addressed.

      We use non-identifying and aggregate information to better design our website(s) and to share with advertisers. For example, we may tell an advertiser that X number of individuals visited a certain area on our website(s), or that Y number of men and Z number of women filled out our registration form, but we would not disclose anything that could be used to identify those individuals.

      We never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.
      Data Security

      To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online.

      Within our organization, we apply access controls to limit the recipients of personal data on a "need to know" basis. Our customer support and technical staff, billing and finance personnel, and representatives of our legal and audit departments have access to your data as necessary for the legitimate purposes of our data processing


      Children's Privacy
      Protecting the privacy of the very young is especially important. For that reason, we do not seek through our sites to gather personal data from or about persons that are minors (i.e., not the age of majority). If you inform us or we otherwise become aware that we have unintentionally received personal data from a minor, we will delete this information from our records.

      Access or Correct Your Information

      We update this Privacy Policy from time to time to reflect changes to our personal data handling practices or respond to new legal requirements and will post updates here. However, if we make any material changes that have a substantive and adverse impact on your privacy, we will provide notice on this(these) website(s) and additionally notify you by email (sent to the e-mail address specified in your account) for your approval prior to the change becoming effective. We encourage you to periodically review this page for the latest information on our privacy practices.

      You can access all your personally identifiable information that we collect online and maintain by login procedure. We use this procedure to better safeguard your information.

      You can correct factual errors in your personally identifiable information by sending us a request that credibly shows error.

      To protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.



      Contact Us	

      Subject to conditions specified by applicable law, persons have the right: 	
      1) to inquire whether and what kind of personal data we hold about you and how it is processed, and to access or request copies of such personal data; 
      2) to request the correction or supplementation of personal data about you that is inaccurate, incomplete or out-of-date in light of the purposes underlying the processing; 
      3) to request to obtain the erasure of personal data no longer necessary for the purposes underlying the processing, processed based on withdrawn consent, processed for legitimate interests that, in the context of your objection, do not prove to be compelling or necessary for the establishment, exercise or defense of legal claims, or processed in non compliance with applicable legal requirements. 

      In addition, you have, subject to the conditions set out in applicable law and without limitation, the rights: 
      1) to request us to restrict the processing of personal data in certain situations where you feel its processing is inappropriate; 
      2) to object, on grounds relating to your particular situation or where your personal data is used for direct marketing purposes, to the processing of personal data for legitimate interests; 
      3) to request portability of personal data that you have provided to us, where the processing of such personal data is based on consent or a contract with you and is carried out by automated means. In case of concerns, you also have the right to lodge a complaint with a supervisory authority having appropriate jurisdiction. 

      Under certain circumstances we will not be able to fulfill your request, such as if it interferes with our regulatory obligations, affects legal matters, we cannot verify your identity, or it involves disproportionate cost or effort, but in any event, we will respond to your request within thirty (30) days and provide you an explanation.
      If you have questions or requests relating to our privacy practices and this Privacy Policy or would like to exercise the mentioned (above) rights of access, rectification, erasure, restriction, objection and data portability, you may contact us using contact information at our website(s).
      Please note that for personal data about you that we have obtained or received for processing on behalf of a separate, unaffiliated entity – which determined the means and purposes of processing, all such requests should be made to that entity directly. We will honor and support any instructions they provide us with respect to your personal information. 
      If you wish to no longer receive marketing communications from us, you also can contact via the contact information of our website(s).



    `
  },
  'help_otp':` 
    <h5>2-Step Verification Setting using Google OTP</h5>
    <section style="margin:30px 0;">
      <h6>1. Activate 2-Step Verification (OTP)</h6>
      <p style="margin-left: 12px;">Click to slide the toggle switch to activate (it should turn green).<br>
      Click to reset OTP settings.</p>
    </section>
    <section style="margin:30px 0;">
      <h6>2. Install Google OTP from Google Play Store or the App Store.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>3. Run Google OTP.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>4. Logout and log back in. You should see a window to register Google OTP.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>5. Select barcode scan in the Google OTP app and register.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>6. Enter in the 6-digit verification code and login.</h6>
    </section>
  `,
  'help_manager': `
    <h5>What are submanager permission?</h5><br>
    <b>Submanager ("Approved by")</b>: Can modify user permission and approve or deny remote access request.<br><br>
    <b>User ("Requested by")</b>: Can be approved by the submanager to access and monitor device(s).
  `,
  'help_vaccine': `
    <h5>Allowed Program Help</h5><br>
    <h6> Enter the name of the installed program (excluding .exe files) to allow.
    </h6>
    <h6 style="padding:0 0 20px 0;">(Leave blank if not using any program)</h6>
  `,
  'help_os': `
    <h5>OS Version Help</h5><br>
    <h6 style="padding:0 0 20px 0;">
      Check the version of your OS below and enter the appropriate number.<br>
    </h6>
    <table>
      <th>OS</th>
      <th style="padding-right:20px;">Major Version</th>
      <th>Minor Version</th>
      <tr>
        <td>Window Server 2019</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window 10</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2016</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2012 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8.1</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2012</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window 7</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Vista</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Home Server</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2003</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP Professional x64 Edition</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window 2000</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">0</td>
      </tr>
    </table>
  `,
  'ip_delete_all_warning':'Do you want to delete ALL the items on the IP List?',
  'ip_delete_all':'Delete All IP',
  'ip_block_reject':`IP is blocked.<br>Contact your administrator.`,
  'ip_white_reject':`IP is is not permitted.<br>Contact your administrator.`,
  'search_manager_200':`Approver has been selected.`,
  'search_manager_405':`Please check the approver ID.`,
  'search_approver_null':'If blank, the approver will be set as the administrator by default.',
  'date_validate_error':'Please check the request date.',
  'approvals_reason':'Please enter the reason for request.',
  'search_approver_placeholder':'Enter the approver ID.',
  'approval-success': `Access request has been made.`,
  'function-settings-desc01': 'Enable/Disable file transfer when creating user accounts.',
  'blocking-settings-desc01': 'Deny access by registering blocked IP list.',
  'blocking-settings-desc02': 'Deny access by registering allowed IP list.',
  'function-submit': 'Your function settings have been changed.',
  'blocking-submit': 'Your security settings have been changed.',
  'blocking-super-settings-desc': 'Enable/Disable IP management policy',
  'reset-pw-repeat': 'Do you want to reset your password?',
  'reset-pw-submit': 'Your password has been reset.<br>Password: {password}', //
  'registration-access': 'Request access has been approved.',
  'registration-reject': 'Request access has been denied.',
  'registration-access-error': 'You may not make an approval if you enter the reason for denial.',
  'registration-reject-error': 'Enter the reason for denial.',
  'login_failed_cause_ip_reject': 'Blocked by the IP settings.',
  'login_failure_limit':'You have made too many login attempts.<br>Please contact your administrator.',
  'registration-approve':'Approve or Deny',
  'registration-reject-history':'Do you want to change the decision?',
  // 추가
  'help_ip_add':`
    <h5>IP Help</h5><br>
    <h6 style="font-weight:bold;">
      Add single IP
    </h6>
    <h6 style="padding:0 0 20px 0;">Only the IP entered will be added.</h6>
    <h6 style="font-weight:bold;">
      Add IP range
    </h6>
    <h6 style="padding:0 0 20px 0;">
      IP address included in the start range to the end range will be added.<br>
      ex. 192.168.0.0 ~ 192.168.0.255
    </h6>
    <h6 style="font-weight:bold;">
      Add subnet IP
    </h6>
    <h6 style="padding:0 0 20px 0;">
      IP addresses partitioned by subnet will be added.<br>
      ex. 192.168.32.0/24
    </h6>
    <h6 style="font-weight:bold;">
      Add via Excel
    </h6>
    <h6 style="padding:0 0 20px 0;">
      Click the <span style="color:#38d2b8;font-weight:bold;">'Excel File Template'</span> below to download. 
      Fill out the form and upload.<br><br>
      You may add a single IP and/or subnet IP address. <br>
      Enter in the start IP address and leave the end address blank.<br><br>
      If adding a IP range, please enter both the start and end IP addresses.<br><br>      
      Only valid IP address will be added.
    </h6>
  `,
  'ip_range_error':'Please check your IP address.',
  'ip_range_blank':'Enter IP address.',
  'ip_excel_no_file':'Upload Excel File.',
  'user_in_group_add':'Enter the ID of the user to add.',
  'user_in_group_no_exist':'User does not exist.',
  'user_in_group_overlap':'User already exists in this group.',
  'user_in_group_blank':'Enter the ID of the user to add.',
  'user_in_group_add_success':'User successfully added.',
  'user_in_group_remove_success':'User successfully deleted.',
  // 'start_time':'Start Date',
  'start_time_time':'Start Time',
  // 'end_time':'End Date',
  'end_time_time':'End Time',
  'auth_failure_num_desc':'If the user exceeds the number of allowed failed attempts, the account will be locked.',
  'auto_block_time':'The session will be automatically terminated if it is not used until the time of value written.',
  'os_version_desc':'After checking user environment, it will be allowed to access only to the higher OS version than the value written.',
  'session_timie_desc':'The session will be automatically terminated if it exceeds the duration time even the session is live.',
  // @@@ 영어로 번역
  'password_level_desc':'Adjust the password difficulty level when you create a user.',
  'capture_desc':'Enable/Disable screen capture or record function.',
  'display_power_save_desc':'Enable/Disable display power saving.',
  'system_power_save_desc':'Enable/Disable system power saving.',
  'security_agreement_desc':'Access will be granted only to the users who agree to the security oath.',
  'function_settings_header':'* Policy Setting: Administrators can change settings for submanagers and users, like remote functions and access environments.',
  'vaccine_desc':'Access will be granted only to the user having its environment of running a specified anti-virus program.',
  'invalid_idle_time':'Please check the remote access idle time limit (min).',
  'invalid_session_time':'Please check the permitted remote session duration (min).',
  'invalid_block_num':'Please check the allowed number of failed verification attempts.',
  'invalid_min_os_major':'Check the major OS version.',
  'invalid_min_os_minor':'Check the minor OS version.',
  'password_modified_error':'Please check the current password.',
  'password_change_limit':'Password usage has expired.<br>Please change your password.',
  'password_expired_desc':'You must change your password before logging in.',
  'invalid_password_change_limit':'Check the Password maximum age (days)',
  'help_PWChangeLimit': `
    <h5>Password Maximum Age Help</h5><br>
    <h6 style="line-hight:1em;">
      Sets the maximum duration for which passwords can be used.<br>
      You can set up to 365 days (1 year).<br>
    </h6>
    <h6 style="padding:20px 0 0 0">
      (Enter 0 if not used)
    </h6>
  `,
  'excel_onloaded':'Only the data with the correct syntax will be added.<br>Select the user to add and submit.',
  'excel_user_submit':'User data was successfully changed with the exception of {failure} error(s).',
  'excel_group_submit':'Group data was successfully changed with the exception of {failure} error(s).',
  'excel_group_fail':'Failed to add multiple groups.<br>Please check the data in your Excel file.',
  'groups':'Groups',
  'users':'Users',
  'dashboard':'Dashboard',
  'payment_manage':'Payment',
  'subscription':'Subscription',
  'payment_history':'Payment History',
  'deleted_device_history':'Deleted Agent History',
  'add_user':'Add User',
  'add_group':'Add Group',
  'access_time':'Access Time',
  'no_devices':'No. of Devices',
  'add_ip':'Add IP',
  'delete_ip':'Delete IP',
  'add_ip_single':'Add single IP',
  'add_ip_range': 'Add IP range',
  'add_ip_subnet':'Add subnet IP',
  'add_ip_excel':'Add via Excel',
  // @@@
  'device_excel_fail': 'Failed to generate Excel.',
  'mode_simple': 'SIMPLE',
  'mode_normal': 'NORMAL',
  'icon_access': 'IN ACCESS',
  'icon_online': 'ON',
  'icon_offline': 'OFF',
  'excel_button' : 'EXCEL',
  'add-group': 'Add Group',
  'add-group-child': 'Add Group - Subgroup',
  'invalid_value': 'Invalid value',
  'app_info_delete': 'Application information has been deleted',
  'app_info_updated': 'Application information has been updated',
  'application_upload_success': 'The application has been uploaded.',
  'application_upload_error': 'Uploading that application failed.',
  'application_add_success': 'You\'ve added an application.',
  'all_application': 'All Applications',
  'application_config': 'Application Configuration',
  'application': 'Application',
  'applications': {
    'title': 'Applications',
    'version': 'Version Check',
    'setting': 'Modify Application Configuration',
    'edit': 'Edit Application Information',
    'delete': 'Delete Application'
  },
  'delete_checked_application_confirm': 'Are you sure you want to delete the selected application?',
  'delete_checked_app_config_confirm': 'Are you sure you want to delete the selected configuration?',
  'config': 'Configuration',
  'basic-config': 'Default',
  'department-members': 'Department Members',
  'admin': 'Admin',
  'middle-managers': 'Middle Managers',
  'all-app-config': 'All Configurations',
  'config-name': 'Name',
  'config-desc': 'Description',
  'config-edit': 'Edit',
  'config-delete': 'Delete',
  'config-copy': 'Copy',
  'location-tracking': 'Enable Location Tracking',
  'enter-pin': 'Enable PIN number',
  'scheduling-updates': 'Scheduling Updates',
  'app_config_info_delete': 'Configuration information has been deleted.',
  'app_config_info_updated': 'Configuration information has been updated.',
  'updated_config_applied': 'The latest configuration information has been applied.',
  'app_config_add_success': 'Configuration information has been added.',
  'pin_flag': 'Request agents to enter PIN number',
  'update-time': 'Update Time',
  'update-time-desc': 'If it is unchecked, updates will start immediately.',
  'installed': 'Installed',
  'not-installed': 'Not Installed',
  'application-add-desc': 'Please add your application with a modification.',
  'application-installation': 'Install that application.',
  'application-not-installation': 'Does not install the application.',
  'select_file': 'Please Select a file.',
  'drop_file': 'Drop the file',
  'application_exist': 'An application that already exists.',
  'select_delete_group': 'Select the groups you want to delete.',
  'select_delete_user': 'Select the user you want to delete.',
  'data_get_fail': 'Failed to import data.',
  'application_add_error': 'Add Application Error',
  'app_config_name': 'Configuration Name',
  'default-item-non-deletable': 'Default items cannot be deleted.',
  'app_name_placeholder': 'App name does not exist. Please enter it manually.',
  'run_after_installation': 'Run after installation',
  'add_application': 'Add Application',
  'add_config': 'Add Configuration',
  'update_schedule_error': 'The update schedule is set incorrectly.',
  'edit_application': 'Edit Application',
  'list_of_users': 'List of users',
  'list_of_devices': 'List of devices',
  'list_of_total_devices': 'List of total devices',
  'confirm': 'Confirm',
  'password_reset_email': 'Sending Password Reset Email',
  'required': 'Required',
  'selections': 'Selections',
  'info_update_interval': 'Device Information Update Interval',
  'dont_show_again': "Don't show again", // 'Don\'t show again'
  'sub_manager_limit': 'The allowed number of sub-users has been exceeded.',
}